import * as zod from 'zod';

export const SchunkEGxCommandDirection = zod.enum(['inward', 'outward']);

export type SchunkEGxCommandDirection = zod.infer<
  typeof SchunkEGxCommandDirection
>;
